<template>
  <BLayoutView
    :back-route="backRoute"
    :title="pageTitle"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"
    :saveable="saveable"
  >
    <template #form>
      <ComponentForm
        ref="form"
        v-bind="viewTypeOptions"
        :data="single"
        :loading="isLoading"
        :editable="editable"
        :saveable="saveable"
        :skeleton="isLoadingAsyncData"
        class="my-4"
      />
    </template>

    <ContextualData :passport-id="single.id" :ate-type="single.ate_type" />

    <ChangesView
      :passport-id="single.id"
      title="История изменений"
      :action-types="['status_updated', 'activate']"
    />

    <ChangesView :passport-id="single.id" title="История изменения объекта АТЕ" :action-types="['ate_api_updated']" />

    <template #footer.right>
      <v-btn
        :to="backRoute"
        depressed
        class="mr-2"
        v-text="'Закрыть'"
      />
    </template>
  </BLayoutView>
</template>

<script>
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { createDeletableMixin } from '@/helpers/mixins/createDeletableMixin'
import { lkPublicationPermissions as Permissions } from '@/helpers/enums/permission-models'
import { PassportsListModel as Model } from './Model'
import { PassportsListStoreModule as StoreModule } from './store'
import { PASSPORTS_LIST_ROUTES as ROUTES } from './utils'
import ComponentForm from './components/PassportForm.vue'
import ContextualData from './components/ContextualData.vue'
import ChangesView from './components/ChangesView/wrapper.vue'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import * as VIEW_TYPES from '@/helpers/enums/view-types'

const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)
const deletableMixin = createDeletableMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */
/** @typedef { import('@/helpers/mixins/createDeletableMixin').DeletableMixin<any, StoreModule> } Deletable */

export default {
  name: 'PassportView',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BLayoutView,
    ChangesView,
    ComponentForm,
    ContextualData,
  },
  mixins: [viewMixin, deletableMixin],
  data: () => ({
    backRoute: { name: ROUTES.LIST },
    isLoadingVariants: true,
  }),
  computed: {
    viewTypeOptions() {
      const { viewType } = this
      return !this.$access(Permissions.edit)
        ? {
          isCreate: false,
          isEdit: false,
          isView: true,
        }
        : {
          isCreate: viewType === VIEW_TYPES.CREATE,
          isEdit: viewType === VIEW_TYPES.EDIT,
          isView: viewType === VIEW_TYPES.VIEW,
        }
    },
    pageTitle() {
      const { single } = this
      if (!single) return ''
      return single.short_name
    },
    data() {
      return this.viewTypeOptions.isCreate ? void 0 : this.single
    },
  },
}
</script>
